module.exports = __webpack_public_path__ + "static/fonts/Roboto500italic.c1d8fbd2.ttf";